import { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import '../assets/css/drawer.css';
import '../assets/css/styles.css';
import separador from '../assets/img/separador.png';
import header from '../assets/img/casas.png';
import Progress from '../components/progress.jsx';
import { DatosUsuario } from '../funciones/sesion.js'
import { Propio } from '../funciones/generales.js'
import { casaFrase, casaIc, casaGradient } from '../funciones/casas.js'
import Drawer from '../components/drawer.jsx'
import Qr from '../components/qr.jsx'

var objSesion;


function Usuario(props) {
    const [icCasa, setIcasa] = useState(0);
    const [casa, setCasa] = useState('');
    const [frase, setFrase] = useState('');
    const [puntos, setPuntos] = useState('');
    const [nombre, setNombre] = useState('');
    const [grad1, setGrad1] = useState('');
    const [grad2, setGrad2] = useState('');
    const [jsonQr, setJsonqr] = useState(0);
    const elements = document.getElementsByClassName('element');
    
    function setUsuarios() {
        objSesion = JSON.parse(localStorage.getItem("session"));
        setIcasa(casaIc(objSesion.casa));
        setCasa(Propio(objSesion.casa));
        setFrase(casaFrase(objSesion.casa));

        setGrad1(casaGradient(objSesion.casa)[1])
        setGrad2(casaGradient(objSesion.casa)[2])

        createRoot(document.getElementById("dg")).render(<Progress />)
        DatosUsuario(objSesion.email).then(data => {
            createRoot(document.getElementById("dg")).unmount(<Progress />)
            setPuntos(data.pts)
            setNombre(data.nombre)
            setJsonqr(JSON.stringify(data));
            const qr = document.getElementById("qr");
            qr.style.opacity = "100";


        });
    }

    useEffect(() => {

        setUsuarios();
        //console.log(document.getElementById("g0").setAttribute("stop-color","#000"));
        /*document.getElementById("g0").setAttribute("stop-color","#fff")
        document.getElementById("g100").setAttribute("stop-color","#000");*/

    }, []);
    return (
        <div className="Sesion">
            <header>

            </header>
            <svg style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }} aria-hidden="true">
                <defs>
                    <linearGradient id="qr-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop id="g0" offset="0%" stop-color={grad1} />
                        <stop id="g100" offset="100%" stop-color={grad2} />
                    </linearGradient>
                </defs>
            </svg>
            
            <div id="dg"></div>
            <div class="container" style={{ overflow: "auto", height: "100vh" }} >
                <div class="inter" style={{ marginTop: 50, maxHeight: "maxHeight" }}>
                    <p class="rage titulo-usuario">{casa}</p>
                    <div class="center-v-">
                        <img src={icCasa} class="img-responsive user-casa" ></img>
                    </div>
                    <div class="top-buffer center-v-">
                        <p>Usuario</p>
                        <p>{nombre}</p>
                        <p>Puntos acumulados</p>
                        <p>{puntos}</p>
                    </div>

                    <div id="qr" style={{ opacity: 0, zIndex: 3 }} class="qr center-v-">
                        <Qr value={jsonQr}
                        />
                    </div>

                    <div>
                        <p class="rage titulo-usuario">{frase}</p>
                    </div>

                </div>

            </div>



        </div>);
}

export default Usuario;